import * as React from 'react';
import styled from 'styled-components';
import * as Colors from '../../constants/colors';
import { Avatar, Card, Button, Row, Col, Tag } from './index';
import { H3, H4 } from '../common';
import { FormattedMessage } from 'react-intl';
import getContext from 'recompose/getContext';
interface Props {
  selected?: boolean;
  headerTitle: string;
  headerSubtitle: React.ReactElement<any>;
  imgUrl: string;
  subheaderTitle: string | JSX.Element;
  subheaderImgUrl: string;
  label: React.ReactElement<any>;
  tagText: string | React.ReactElement<FormattedMessage>;
  tagColor: string;
  buttonText: string | React.ReactElement<FormattedMessage>;
  onClick: React.EventHandler<any>;
}

const RightCard = styled(Card)`
  height: 100%;
  border-top: 0;
  border-bottom: 0;
  text-align: center;
  ..ant-card-body {
    padding: 10px;
  }
`;

const TopHeaderRow = styled(Row)`
  border-bottom: 1px solid #eee;
  padding: 1em 2em;
`;

const AvatarCol = styled(Col)`
  padding-top: 1em;
  max-width: 50px;
`;

const SubHeadingRow = styled(Row)`
  padding: 1em 2em;
`;

const InlinedH4 = styled(H4)`
  display: inline-block;
`;

const AvatarWrapper = styled.div`
  padding-right: 1em;
`;

const StyledTag = styled(Tag)`
  color: ${Colors.primaryColor};
`;

// TODO: combine with SmallCard.
const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 1em;
`;

const RowResult: React.SFC<Props & AppContext> = props => (
  <Card bodyStyle={{ padding: 0 }} noHovering>
    <Row type="flex">
      <Col span={24} md={19}>
        <TopHeaderRow>
          <H3>{props.headerTitle}</H3>
        </TopHeaderRow>
        <SubHeadingRow>
          <Row type="flex" align="middle" justify="start" gutter={8}>
            <AvatarCol xl={24} sm={4}>
              <Avatar
                shape="square"
                size="large"
                icon="user"
                src={props.imgUrl}
              />
            </AvatarCol>

            {props.isMobile && (
              <Col md={20}>
                <StyledTag color={props.tagColor}>{props.tagText}</StyledTag>
              </Col>
            )}
            <Col
              xl={24}
              sm={20}
              style={
                props.isMobile
                  ? {
                      width: '100%',
                      borderTop: `1px solid ${Colors.moonGray}`,
                      paddingTop: 10,
                      marginTop: 10,
                    }
                  : undefined
              }
            >
              <Row type="flex" align="middle">
                {!props.isMobile && (
                  <StyledTag color={props.tagColor}>{props.tagText}</StyledTag>
                )}
                <AvatarWrapper>
                  <Avatar
                    shape="square"
                    size="small"
                    icon="user"
                    src={props.subheaderImgUrl}
                  />
                </AvatarWrapper>
                <InlinedH4>{props.subheaderTitle}</InlinedH4>
              </Row>
              <Row>{props.label}</Row>
            </Col>
          </Row>
        </SubHeadingRow>
      </Col>
      <Col span={24} md={5}>
        <RightCard>
          <H3>{props.headerSubtitle}</H3>
          <StyledButton
            size="large"
            icon={props.selected ? 'close' : 'plus'}
            onClick={props.onClick}
            type={props.selected ? undefined : 'primary'}
          >
            {props.buttonText}
          </StyledButton>
        </RightCard>
      </Col>
    </Row>
  </Card>
);
export default getContext({ isMobile: React.PropTypes.bool })(RowResult);



// WEBPACK FOOTER //
// ./app/components/antd/RowResult.tsx